import { singleton } from '~/decorators/dependency-container'
import { Log } from '~/models/log'

@singleton()
export class LogFormatter {
  formatLog(l: any): Log {
    return {
      changes: l.changes || l.data,
      idents: l.idents,
      action: l.human_action || l.action,
      created: l.created,
      actor: l.actor,
      clientInfo: l.client_info,
      instance: l.instance,
      ip: l.ip
    }
  }
}
